import React from 'react';
import Box from '@mui/material/Box';

import { useSalonPublicTheme } from '../../../context/SalonPublicThemeContext';


const SalonPublicServices = ({ children, sx, ...props }) => {
  const { layout } = useSalonPublicTheme();
  const { services: serviceMode, serviceColumns } = layout.tokens.content;
  const desktopColumns = serviceMode === 'grid' ? serviceColumns : 1;
  const columns = serviceMode === 'grid'
    ? { mobile: 1, tablet: 2, desktop: desktopColumns }
    : { mobile: 1, tablet: 1, desktop: 1 };

  return (
    <Box
      {...props}
      component="div"
      role="list"
      dir={layout.tokens.direction}
      data-services={serviceMode}
      data-columns-mobile={columns.mobile}
      data-columns-tablet={columns.tablet}
      data-columns-desktop={columns.desktop}
      sx={{
        display: 'grid',
        gridTemplateColumns: serviceMode === 'grid'
          ? {
            xs: 'minmax(0, 1fr)',
            sm: 'repeat(2, minmax(0, 1fr))',
            lg: `repeat(${desktopColumns}, minmax(0, 1fr))`,
          }
          : 'minmax(0, 1fr)',
        gap: serviceMode === 'grid' ? 3 : 2,
        p: 0,
        m: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default SalonPublicServices;
